import Primary from "../layouts/Primary";

import './Message.css'
import {DisplayCommand, ShowMessage} from "../../javaTypes";

export default function Message({command} : {
    command: DisplayCommand<ShowMessage>
}) {
       return <Primary>
           {command.params.message.trim().length > 0 ? <div className={`messageWrapper ${command.params.message.includes("<img") ? "imageMessage" : ""}`}>
               <div className={"messageInnerWrapper"}>
                   <div dangerouslySetInnerHTML={{__html: command.params.message}} />
               </div>
           </div> : null}
    </Primary>;
}